import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { AllowanceProposalsReadApiClient } from '~/services/Http';

import {
  AllowanceDto,
  Order4,
  WorkflowStatuses2,
} from '../../client.rewarding.generated';

export const GET_ALLOWANCE_PROPOSALS_SWR_KEY =
  'AllowanceProposalsReadApiClient.getAllProposals';

export function useGetAllowanceProposals(
  args?: {
    order?: Order4;
    offset?: number;
    limit?: number;
    startDate?: Date;
    endDate?: Date;
    lang?: string;
    includeHistory?: boolean;
    uids?: string[];
    employeeIds?: number[];
    unitIds?: number[];
    roles?: string[];
    workflowStatuses?: WorkflowStatuses2[];
    workflowHandlers?: number[];
    sort?: string[];
  },
  swrConfig?: SWRConfiguration<AllowanceDto[]>,
  disable?: boolean,
): UseSWROutput<AllowanceDto[]> {
  return useSWR(
    !disable
      ? [
          GET_ALLOWANCE_PROPOSALS_SWR_KEY,
          args?.order ?? undefined,
          args?.offset ?? undefined,
          args?.limit ?? undefined,
          args?.startDate ?? undefined,
          args?.endDate ?? undefined,
          args?.lang ?? undefined,
          args?.includeHistory ?? undefined,
          args?.uids ?? undefined,
          args?.employeeIds ?? undefined,
          args?.unitIds ?? undefined,
          args?.roles ?? undefined,
          args?.workflowStatuses ?? undefined,
          args?.workflowHandlers ?? undefined,
          args?.sort ?? undefined,
        ]
      : null,
    ([
      _,
      order,
      offset,
      limit,
      startDate,
      endDate,
      lang,
      includeHistory,
      uids,
      employeeIds,
      unitIds,
      roles,
      workflowStatuses,
      workflowHandlers,
      sort,
    ]) =>
      AllowanceProposalsReadApiClient.getAllProposals(
        order,
        offset,
        limit,
        startDate,
        endDate,
        lang,
        includeHistory,
        uids,
        employeeIds,
        unitIds,
        roles,
        workflowStatuses,
        workflowHandlers,
        sort,
      ).then((r) => r.data),
    swrConfig,
  );
}
